<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/5z7rNT/images/e9781439632161_cover.jpg?1684161153735" alt="This image is the cover for the book Long Island Airports, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Long Island Airports, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p>Long Island is a natural airfield. The central area of Long Island�s Nassau County�known as the Hempstead Plains�is the only natural prairie east of the Allegheny Mountains. The island itself is ideally placed at the eastern edge of the United States, adjacent to its most populous city. In fact, nowhere else in America has so much aviation activity been confined to such a relatively small geographic area. The many record-setting and historic flights and the aviation companies that were developed here have helped place Long Island on the aviation map.  Through one hundred years of aviation history, Long Island has been home to eighty airfields. From military airfields to seaplane bases and commercial airports, the island has had more airports than any other place of similar geographic proportion in America. Most have vanished without a trace, but a handful remains. Long Island Airports is the first book to document the pictorial history of these airports and airfields.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Joshua Stoff
      </h2>
      
      <p class="authorDescription body article">Joshua Stoff is the curator of the Cradle of Aviation Museum on Long Island, and is a noted aviation historian. He is the author of numerous aviation and space titles, including Arcadia Publishing�s Long Island Aircraft Crashes: 1909�1959 and Building Moonships: The Grumman Lunar Module.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?22843f4a